import { SUPPORT_TYPE } from '../constants';
import { service } from './';

const { resource } = service;
export const dummyImagePath = `${resource}/editor/dummy/dummy_image.png`;
export const dummyImageSmallPath = `${resource}/editor/dummy/dummy_image_small.png`;
export const dummyMapPath = `${resource}/editor/dummy/dummy_map.png`;
export const dummyVideoPath = `${resource}/editor/dummy/dummy_video.png`;
export const dummyHeaderPath = `${resource}/editor/dummy/dummy_header.png`;

export const defaultContent = {
	"text": "여기에 내용을 입력하세요.",
	"imagePath": dummyImagePath,
	"imageAlt": "",
	"imageLink": "",
	"buttonText": "버튼 이름",
	"buttonLink": ""
}

export const textDefault = {
	fontFamily: 'AppleSDGothic, apple sd gothic neo, noto sans korean, noto sans korean regular, noto sans cjk kr, noto sans cjk, nanum gothic, malgun gothic, dotum, arial, helvetica, sans-serif',
	fontSize: '16px',
	color: '#000000',
	textAlign: 'left',
	padding: 0,
	margin: 0,
	lineHeight: "1.7"
}

export const boxDefault = {
	background: "",
	paddingTop: "15px",
	paddingBottom: "15px",
	paddingRight: "15px", 
	paddingLeft: "15px",
	textAlign: "left",
	lineHeight: "1px",
	borderStyle: "solid",
	borderWidth: "0px",
	borderColor: "",
}

export const buttonDefault = {
	fontSize: "16px",
	display: "inline-block",
	color: "#ffffff",
	background: "#3A79E3",
	borderRadius: "3px",
	borderStyle: "solid",
	borderWidth: "0px",
	borderColor: "",
	padding: "19px 20px",
	textDecoration: "none",
	textAlign: "center",
	outline: "0",
	fontFamily: textDefault.fontFamily,
	lineHeight: 1,
	boxSizing: 'border-box',
	buttonType: 'square-full'
}

export const imageDefault = {
	width: "100%",
	originalWidth: '',
	display: "inline",
	verticalAlign: "bottom",
	textAlign: "justify",
	maxWidth: "100%",
	height: "auto",
	border: "0",
	fullWidth: "justify"
}

export const partitionDefault = {
	height: "1px",
	background: "none",
	display: "block",
	margin: "0 0",
	padding: "0 0 0 0",
	borderTopWidth: "1px",
	borderTopStyle: "solid",
	borderTopColor: "#999999"
}

export const linkDefault = {
	fontWeight: "normal",
	fontStyle: "normal",
	textDecoration: "none",
	color: "#0000ff"
}

const columnDefault = {
	// paddingRight: "0",
	// paddingLeft: "0",
}

const outerDefault = {
	// paddingRight: "0",
	// paddingLeft: "0",
}

export const shopTypeSet:any = {
	shopA: [['image', 'text', 'text', 'text', 'text', 'cta']],
	shopB: [['image', 'text_hide', 'text_hide', 'text_hide', 'text_hide', 'cta_hide'], ['image_hide', 'text', 'text', 'text', 'text', 'cta']],
	shopC: [['image', 'text', 'text', 'text', 'text', 'cta'], ['image', 'text', 'text', 'text', 'text', 'cta']],
}

export const components: any[] = [
	{
		name: '웹에서 보기',
		text: 'permalink',
		plan: 'all',
		value: {
			"group": "permalink",
			"show": false,
			"drag": false,
			"type": "permalink",
			"typeText": "웹에서 보기",
			"category": "permalink",
			"supportType": SUPPORT_TYPE.EMAIL,
			"column": [
				[]
			],
			"content": [{
				"text": "<span style='color:#747579;font-size:12px;text-decoration:none' data-mce-style='color:#747579;font-size:12px;text-decoration:none'><a href='$%permalink%$' target='_blank' style='color:#747579;text-decoration:inherit' data-mce-style='color:#747579;text-decoration:inherit'>이 메일이 잘 안보이시나요?</a></span>",
				"imagePath": dummyImagePath,
				"imageAlt": "",
				"imageLink": "",
				"buttonText": "",
				"buttonLink": ""
			}],
			"style": [{
				"box": {
					...boxDefault,
					lineHeight: "1.7",
					textAlign: "center",
				},
				"text": {
					...textDefault,
					"textAlign": "left",
					"fontSize": "12px",
					"color": "#747579",
				},
				column: {...columnDefault},
				outer: {...outerDefault}
			}]
		}
	},
	{
		name: '텍스트',
		text: 'textOnly',
		plan: 'all',
		value: {
			"group": "text",
			"show": false,
			"drag": false,
			"type": "textOnly",
			"typeText": "텍스트",
			"category": "base",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				['text']
			],
			"content": [{
				...defaultContent
			}],
			"style": [{
				"box": {
					...boxDefault
				},
				"text": {
					...textDefault
				},
				"image": {
					...imageDefault
				},
				"button": {
					...buttonDefault
				},
				column: {...columnDefault},
				outer: {...outerDefault}
			}]
		}
	},
	{
		name: '이미지',
		text: 'imageOnly',		
		plan: 'all',
		value: {
			"group": "image",
			"show": false,
			"drag": false,
			"type": "imageOnly",
			"typeText": "이미지",
			"category": "base",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				['image']
			],
			"content": [{
				...defaultContent
			}],
			"style": [{
				"box": {
					...boxDefault
				},
				"text": {
					...textDefault
				},
				"image": {
					...imageDefault
				},
				"button": {
					...buttonDefault
				},
				column: {...columnDefault},
				outer: {...outerDefault}
			}]
		}
	},
	{
		name: '버튼',
		text: 'CTAOnly',
		plan: 'all',
		value: {
			"group": "itb",
			"show": false,
			"drag": false,
			"type": "CTAOnly",
			"typeText": "버튼",
			"category": "base",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				['cta']
			],
			"content": [{
				...defaultContent
			}],
			"style": [{
				"box": {
					...boxDefault,
				},
				"text": {
					...textDefault
				},
				"image": {
					...imageDefault
				},
				"button": {
					...buttonDefault
				},
				column: {...columnDefault},
				outer: {...outerDefault}
			}]
		}
	},
	{
		name: '1단 가로',
		text: 'cntB',
		plan: 'all',
		value: {
			"group": "imt",
			"show": false,
			"drag": false,
			"type": "cntB",
			"category": "base",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				['image'], ['text', 'cta']
			],
			"typeText": "1단 가로",
			"content": [{
					...defaultContent
				},
				{
					...defaultContent
				}],
			"style": [{
				"column": {
					...columnDefault
				},
				outer: {...outerDefault},
				"box": {
					...boxDefault
				},
				"text": {
					...textDefault,
				},
				"image": {
					...imageDefault
				},
				"button": {
					...buttonDefault,
					"textAlign": "left"
				},
				"order": ["imageOnly", "textOnly"]
			}, {
				"text": {
					...textDefault,
				}
			}]
		}
	},
	{
		name: '2단',
		text: 'multiB',
		plan: 'all',
		value: {
			"group": "imt",
			"show": false,
			"drag": false,
			"type": "multiB",
			"category": "base",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				['image', 'text'], ['image', 'text']
			],
			"typeText": "2단",
			"content": [{
				...defaultContent
			}, {
				...defaultContent
			}],
			"style": [{
				"column" :{
					...columnDefault
				},
				outer: {...outerDefault},
				"box": {
					...boxDefault,
				},
				"text": {
					...textDefault,
				},
				"image": {
					...imageDefault
				},
				"button": {
					...buttonDefault
				}
			}, {
				"box": {
					...boxDefault,
				},
				"text": {
					...textDefault,
				},
				"image": {
					...imageDefault
				},
				"button": {
					...buttonDefault
				}
			}]
		}
	},
	{
		name: '구분선',
		text: 'partition',
		plan: 'all',
		value: {
			"group": "partition",
			"show": false,
			"drag": false,
			"type": "partition",
			"category": "partition",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				[]
			],
			"typeText": "구분선",
			"content": [{
				...defaultContent
			}],
			"style": [{
				"box": {
					...boxDefault
				},
				outer: {...outerDefault},
				"partition": {
					"height": "1px",
					"background": "none",
					"display": "block",
					"margin": "0 0",
					"padding": "0 0 0 0",
					"borderTopWidth": "1px",
					"borderTopStyle": "solid",
					"borderTopColor": "#999999"
				}
			}]
		}
	},
	{
		name: 'SNS 공유',
		text: 'share',
		plan: 'all',
		value: {
			"group": "share",
			"show": false,
			"drag": false,
			"type": "share",
			"typeText": "SNS 공유",
			"category": "share",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				[]
			],
			"content": [{
				"share": [
					{
						"id": 0,
						"value": "facebook",
						"label": "공유하기",
						"active": true,
						"alt": "페이스북",
					},
					{
						"id": 1,
						"value": "twitter",
						"label": "게시하기",
						"active": true,
						"alt": "플랫폼 X",
					},
					{
						"id": 2,
						"value": "web",
						"label": "웹에서 보기",
						"active": true,
						"alt": "링크",
					},
					{
						"id": 3,
						"value": "linkedin",
						"label": "공유하기",
						"active": false,
						"alt": "링크드인",
					},
				]
			}],
			"style": [{
				"box": {
					...boxDefault,
					"lineHeight": "1.7",
					"textAlign": "center",
					"snsStyle": "snsA",
					"snsMargin": "0 auto 0 auto"
				},
				"text": {
					...textDefault,
					"fontSize": "12px",
					"color": "#606060",
					"textAlign": "center"
				},
				outer: {...outerDefault}
			}]
		}
	},
	{
		name: 'SNS 링크',
		text: 'sns',
		plan: 'all',
		value: {
			"group": "paste",
			"show": false,
			"drag": false,
			"type": "sns",
			"typeText": "SNS 링크",
			"category": "sns",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				[]
			],
			"content": [{
				...defaultContent,
				"sns": [{
					"id": 0,
					"value": "homepage",
					"label": "웹사이트",
					"url": "https://",
					"active": true,
					"icon": "https://stibee.com/assets\/images\/sns\/white\/sns_icon_homepage.png",
					"icon_g": "https://stibee.com/assets\/images\/sns\/grey\/sns_icon_homepage.png",
					"background": "#4F649D"
				}, {
					"id": 1,
					"value": "facebook",
					"label": "페이스북",
					"url": "https://",
					"active": true,
					"icon": "https://stibee.com/assets\/images\/sns\/white\/sns_icon_facebook.png",
					"icon_g": "https://stibee.com/assets\/images\/sns\/grey\/sns_icon_facebook.png",
					"background": "#44619D"
				}, {
					"id": 3,
					"value": "blog",
					"label": "블로그",
					"url": "https://",
					"active": true,
					"icon": "https://stibee.com/assets\/images\/sns\/white\/sns_icon_blog.png",
					"icon_g": "https://stibee.com/assets\/images\/sns\/grey\/sns_icon_blog.png",
					"background": "#FF9801"
				}, {
					"id": 5,
					"value": "youtube",
					"label": "유튜브",
					"url": "https://",
					"active": true,
					"icon": "https://stibee.com/assets\/images\/sns\/white\/sns_icon_youtube.png",
					"icon_g": "https://stibee.com/assets\/images\/sns\/grey\/sns_icon_youtube.png",
					"background": "#cc181e"
				}, {
					"id": 6,
					"value": "brunch",
					"label": "브런치",
					"url": "https://",
					"active": true,
					"icon": "https://stibee.com/assets\/images\/sns\/white\/sns_icon_brunch.png",
					"icon_g": "https://stibee.com/assets\/images\/sns\/grey\/sns_icon_brunch.png",
					"background": "#89B524"
				}]
			}],
			"style": [{
				"box": {
					...boxDefault,
					"textAlign": "center",
					"snsStyle": "snsA",
					"snsMargin": "0 auto 0 auto"
				},
				"text": {
					...textDefault,
					"fontSize": "12px",
					"color": "#000",
				},
				outer: {...outerDefault}
			}]
		}
	},
	{
		name: '지도',
		text: 'map',
		plan: 'all',
		value: {
			"group": "paste",
			"show": false,
			"drag": false,
			"type": "map",
			"typeText": "지도",
			"category": "map",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				[]
			],
			"content": [{
				...defaultContent,
				"imagePath": dummyMapPath,
				"address": '',
			}],
			"style": [{
				"box": {
					...boxDefault,
				},
				"text": {
					...textDefault
				},
				"image": {
					...imageDefault
				},
				outer: {...outerDefault}
			}]
		}
	},
	{
		name: '동영상 미리보기',
		text: 'video',
		plan: 'all',
		value: {
			"group": "image",
			"show": false,
			"drag": false,
			"type": "video",
			"typeText": "동영상 미리보기",
			"category": "video",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				[]
			],
			"content": [{
				...defaultContent,
				"imagePath": dummyVideoPath,
			}],
			"style": [{
				"box": {
					...boxDefault,
				},
				"image": {
					...imageDefault,
					"textAlign": "center"
				},
				outer: {...outerDefault},
				"videobox": {
					"width": "100%",
					"position": "relative",
					"paddingBottom": "56.25%",
				},
				"embedvideo": {
					"display": "block",
					"position": "absolute",
					"width": "100%",
					"height": "100%",
				},
			}]
		}
	},
	{
		name: '상품 구매하기',
		text: 'shopA',
		plan: 'all',
		value: {
			"group": "itb",
			"show": false,
			"drag": false,
			"type": "shopA",
			"category": "shop",
			"column": [['image', 'text', 'text', 'text', 'text', 'cta']],
			"typeText": "상품 구매하기",
			"supportType": SUPPORT_TYPE.ALL,
			"content": [
				[
					{
						"imagePath": dummyImagePath,
						"imageAlt": "",
						"imageLink": "",
						"show": true,
						"product": {
							"product_url": "",
							"product_code": "",
							"product_name": "",
							"price": "",
							"summary_description": "",
							"detail_image": "",
							"discountprice": {
								"pc_discount_price": "",
								"mobile_discount_price": ""
							}
						}
					},
					{
						"text": "<div style='text-align: center;'><span style='font-size: 18px;'>상품 이름을 입력하세요</span></div>",
						"show": true
					},
					{
						"text": "<div style='text-align: center;'><span style='font-style: normal; text-decoration-line: line-through; color: #999999;font-size: 14px;'>00,000</span></div>",
						"show": true
					},
					{
						"text": "<div style='text-align: center;'><span style='font-style: normal; color: #000000;font-size: 14px;'>00,000</span></div>",
						"show": true
					},
					{
						"text": "<div style='text-align: center;'><span style='font-size: 12px; color: #999999;'>상품 설명 내용을 입력하세요</span></div>",
						"show": true
					},
					{
						"buttonText": "상품 구매하기",
						"buttonLink": "",
						"show": true
					}
				],
				[
					{
						"imagePath": dummyImagePath,
						"imageAlt": "",
						"imageLink": "",
						"show": true,
						"product": {
							"product_url": "",
							"product_code": "",
							"product_name": "",
							"price": "",
							"summary_description": "",
							"detail_image": "",
							"discountprice": {
								"pc_discount_price": "",
								"mobile_discount_price": ""
							}
						}
					},
					{
						"text": "<div style='text-align: center;'><span style='font-size: 18px;'>상품 이름을 입력하세요</span></div>",
						"show": true
					},
					{
						"text": "<div style='text-align: center;'><span style='font-style: normal; text-decoration-line: line-through; color: #999999;font-size: 14px;'>00,000</span></div>",
						"show": true
					},
					{
						"text": "<div style='text-align: center;'><span style='font-style: normal; color: #000000;font-size: 14px;'>00,000</span></div>",
						"show": true
					},
					{
						"text": "<div style='text-align: center;'><span style='font-size: 12px; color: #999999;'>상품 설명 내용을 입력하세요</span></div>",
						"show": true
					},
					{
						"buttonText": "상품 구매하기",
						"buttonLink": "",
						"show": true
					}
				]
			],
			"style": [
				[
					{
						"box": {
							...boxDefault,
							// "paddingTop": "10px",
							// "paddingBottom": "5px",
						},
						"image": {
							"width": "100%",
							"display": "inline",
							"verticalAlign": "middle",
							"max-width": "100%",
							"height": "auto",
							"border": "0"
						}
					},
					{
						"box": {
							...boxDefault,
							// "paddingTop": "10px",
							// "paddingBottom": "5px",
						},
						"text": {
							...textDefault,
							// "margin": "10px 0 5px 0",
						}
					},
					{
						"box": {
							...boxDefault,
							// "paddingTop": "10px",
							// "paddingBottom": "5px",
						},
						"text": {
							...textDefault,
							// "margin": "10px 0 5px 0",
						}
					},
					{
						"box": {
							...boxDefault,
							"paddingTop": "10px",
							"paddingBottom": "5px",
						},
						"text": {
							...textDefault,
							// "margin": "10px 0 5px 0",
						}
					},
					{
						"box": {
							...boxDefault,
							// "paddingTop": "10px",
							// "paddingBottom": "5px",
						},
						"text": {
							...textDefault,
							// "margin": "10px 0 5px 0",
						}
					},
					{
						"box": {
							...boxDefault,
							"paddingTop": "14px",
							"paddingBottom": "11px",
							"textAlign": "center",
						},
						"button": {
							...buttonDefault
						}
					},
					{
						"order": [
							"image",
							"text",
							"text",
							"text",
							"text",
							"CTA"
						]
					}
				],
				[
					{
						"box": {
							...boxDefault,
							// "paddingTop": "10px",
							// "paddingBottom": "5px",
							"paddingRight": 0,
							"paddingLeft": 0,
						},
						"image": {
							...imageDefault,
							textAlign: "",
						}
					},
					{
						"box": {
							...boxDefault,
							// "paddingTop": "10px",
							// "paddingBottom": "5px",
						},
						"text": {
							...textDefault,
							// "margin": "10px 0 5px 0",
						}
					},
					{
						"box": {
							...boxDefault,
							// "paddingTop": "10px",
							// "paddingBottom": "5px",
						},
						"text": {
							...textDefault,
							// "margin": "10px 0 5px 0",
						}
					},
					{
						"box": {
							...boxDefault,
							// "paddingTop": "10px",
							// "paddingBottom": "5px",
						},
						"text": {
							...textDefault,
							// "margin": "10px 0 5px 0",
						}
					},
					{
						"box": {
							...boxDefault,
							// "paddingTop": "10px",
							// "paddingBottom": "5px",
						},
						"text": {
							...textDefault,
							// "margin": "10px 0 5px 0",
						}
					},
					{
						"box": {
							...boxDefault,
							"paddingTop": "14px",
							"paddingBottom": "11px",
							"textAlign": "center",
						},
						"button": {
							...buttonDefault
						}
					},
					{
						"order": [
							"image",
							"text",
							"text",
							"text",
							"text",
							"CTA"
						]
					}
				]
			]
		}
	},
	{
		name: '후원하기',
		text: 'donationA',
		plan: 'donation',
		value: {
			"group": "itb",
			"show": false,
			"drag": false,
			"type": "donationA",
			"typeText": "후원하기",
			"category": "donation",
			"column": [['cta']],
			"supportType": SUPPORT_TYPE.ALL,
			"content": [
				{
					"text": "후원하기",
					"imagePath": dummyImagePath,
					"imageAlt": "",
					"imageLink": "",
					"buttonText": "후원하기",
					"buttonLink": "",
				},
				{
					"text": "후원하기",
					"imagePath": dummyImagePath,
					"imageAlt": "",
					"imageLink": "",
					"buttonText": "후원하기",
					"buttonLink": "",
				}
			],
			"style": [
				{
					"box": {
						...boxDefault,
						"paddingTop": "15px",
						"paddingBottom": "15px",
						"textAlign": "center",
					},
					"button": {
						...buttonDefault
					}
				},
				{
					"box": {
						...boxDefault,
						"paddingTop": "15px",
						"paddingBottom": "15px",
						"textAlign": "center",
					},
					"button": {
						...buttonDefault
					}
				}
			]
		}
	},	
	{
		name: 'HTML 코드',
		text: 'htmlcode',
		plan: 'standard',
		value: {
			"group": "none",
			"show": false,
			"drag": false,
			"type": "htmlcode",
			"typeText": "HTML 코드",
			"category": "htmlcode",
			"column": [[]],
			"supportType": SUPPORT_TYPE.ALL,
			"content": [
				{
					text:'<div>여기를 클릭하고 오른쪽 패널에서 HTML 코드를 입력하세요.</div>'
				}
			],
			"style": [
				{
					"box": {
						...boxDefault,
					},
					outer: {...outerDefault}
				}
			],
			"edited": [],
			"editing": false
		}
	},
	{
		name: '푸터',
		text: 'footer',
		plan: 'all',
		value: {
			"group": "footer",
			"show": false,
			"drag": false,
			"type": "footer",
			"typeText": "푸터",
			"category": "footer",
			"column" :[[]],
			"supportType": SUPPORT_TYPE.ALL,
			"content": [{
				"text": "$%회사이름%$<br>$%이메일주소%$<br>$%주소%$ $%전화번호%$<br><a href=$%unsubscribe%$>수신거부</a><a href=$%unsubscribe%$>Unsubscribe</a>",
				"imagePath": dummyImagePath,
				"imageAlt": "",
				"imageLink": "",
				"buttonText": "버튼 이름",
				"buttonLink": ""
			}],
			"style": [{
				"box": {
					...boxDefault
				},
				"text": {
					...textDefault,
					"fontSize": "12px",
					"color": "#747579",
					"textAlign": "center"
				},
				column: {...columnDefault},
				outer: {...outerDefault}
			}]
		}
	},
	{
		name: '공백',
		text: 'spacer',
		plan: 'all',
		value: {
			"group": "spacer",
			"show": false,
			"drag": false,
			"type": "spacer",
			"typeText": "공백",
			"category": "spacer",
			"column" :[[]],
			"supportType": SUPPORT_TYPE.ALL,
			"content": [{
				"text": "ddd",
				"imagePath": dummyImagePath,
				"imageAlt": "",
				"imageLink": "",
				"buttonText": "버튼 이름",
				"buttonLink": ""
			}],
			"style": [{
				"box": {
					...boxDefault,
					height: '50px',
					padding: 0,
					background: 'none'
				},
				"text": {
					...textDefault,
				},
				column: {...columnDefault},
				outer: {...outerDefault}
			}]
		}
	},
	{
		name: '네이버 광고',
		text: 'naverAd',
		plan: 'all',
		value: {
			"group": "image",
			"show": false,
			"drag": false,
			"type": "naver-ad",
			"typeText": "네이버 광고",
			"category": "naver-ad",
			"supportType": SUPPORT_TYPE.ALL,
			"column": [
				['ad']
			],
	"content": [{
		"adImageUrl": `$%$adIDImage%$`,
		"adLink": `$%$adIDRedirect%$`,
		"adAlt": "",
		"adKeyword": ""
	}],
		"style": [{
			"box": {
				...boxDefault,
				"textAlign": "center",
			},
			"image": {
				...imageDefault,
				"width": "500px",
				"textAlign": "center",
				"originalWidth": "500",
				"fullWidth": ""
			},
			column: {...columnDefault},
			outer: {...outerDefault}
		}]
		}
	},
]
